import Swiper from 'swiper/bundle';
import 'swiper/css/bundle';

export function swiper1() {

  const swiper1 = new Swiper('.swiper-container-1', {

    slidesPerView: 1,
    slidesPerGroup: 1,
    spaceBetween: 10,
    

    // Navigation arrows
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },


  });
}
